import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"

/*
Exemplo de uso:
  <input data-controller='mask'
         data-mask-format-value='time'>
*/

export default class extends Controller {
  static values = { format: String }

  connect() {
    switch(this.formatValue) {
      case 'time':
        this.maskTime()
        break;

      case 'cellphone':
        this.maskCellPhone()
        break;

      case 'cpf':
        this.maskCpf()
        break;

      default:
        console.log('mask_controller - invalid format')
    }
  }

  maskTime() {
    new Cleave(this.element, {
      time: true,
      timePattern: ['h', 'm']
    })
  }

  maskCellPhone() {
    new Cleave(this.element, {
      blocks: [0, 2, 5, 4],
      delimiters: ['(', ') ', '-']
      //uppercase: true
    })
  }

  maskCpf() {
    new Cleave(this.element, {
      blocks: [3, 3, 3, 2],
      delimiters: ['.', '.', '-'],
      numericOnly: true
    })
  }
}
